import { useState, useEffect, useCallback } from "react";
// import { useHistory } from "react-router-dom";

export const useEditMode = (el) => {
  const [inEditMode, setEditMode] = useState(false);
  const [markedItems, editMarkedItems] = useState([]);
  // const history = useHistory;

  useEffect(() => {
    let root = el || document.body;
    setColours(root, true);
  }, []);

  function resetEditMode() {
    setEditMode((currentMode) => {
      let root = document.body;

      setColours(root, true);

      return !currentMode;
    });

    editMarkedItems([]);
  }

  function setColours(root, currentMode) {
    let backgroundColor;
    let formLabelColor;

    root.classList.toggle("brah");
    if (currentMode === true) {
      backgroundColor = "white";
      formLabelColor = "var(--timesheets-secondary)";
    } else {
      backgroundColor = "var(--editBlack)";
      formLabelColor = "var(--editBlack)";
    }

    // let backgroundColor = currentMode === true ? "white" : "var(--editBlack)";
    // let formLabelColor =
    //   currentMode === true ? "var(--timesheets-secondary)" : "var(--editBlack)";

    // root = document.body;
    root.style.setProperty("--background", backgroundColor);
    root.style.setProperty("--label-editable", formLabelColor);
  }

  function toggleEditMode(el) {
    setEditMode((currentMode) => {
      let root = el || document.documentElement;
      setColours(root, currentMode);

      return !currentMode;
    });

    editMarkedItems([]);
  }

  // const isMarked = useCallback(
  //   (itemId) => {
  //     let marked = false;
  //     if (markedItems.includes(itemId)) {
  //       marked = true;
  //     }
  //     return marked;
  //   },
  //   [markedItems]
  // );

  const isMarked = useCallback(
    (itemId) => {
      return markedItems.includes(itemId);
    },
    [markedItems]
  );

  // function isMarked(itemId) {
  //   let marked = false;
  //   if (markedItems.includes(itemId)) {
  //     marked = true;
  //   }
  //   return marked;
  // }

  // function markItem(item) {
  //   let itemId = item.uid;

  //   editMarkedItems((marked) => {
  //     if (isMarked(itemId)) {
  //       return marked.filter((uid) => uid !== itemId);
  //     } else {
  //       return [...marked, itemId];
  //     }
  //   });
  // }

  // const markItem = useCallback(
  //   (item) => {
  //     let itemId = item.uid;

  //     editMarkedItems((marked) => {
  //       if (isMarked(itemId)) {
  //         return marked.filter((uid) => uid !== itemId);
  //       } else {
  //         return [...marked, itemId];
  //       }
  //     });
  //   },
  //   [isMarked]
  // );

  const markItem = useCallback((item) => {
    let itemId = item.uid;

    editMarkedItems((marked) => {
      if (marked.includes(itemId)) {
        return marked.filter((uid) => uid !== itemId);
      } else {
        return [...marked, itemId];
      }
    });
  }, []);

  const markMonth = useCallback(
    (items) => {
      console.log("hello?", items);
      if (inEditMode) {
        items.forEach((ts) => {
          markItem(ts);
        });
      }
    },
    [markItem, inEditMode]
  );

  return {
    inEditMode,
    toggleEditMode,
    resetEditMode,
    isMarked,
    markMonth,
    markItem,
    markedItems,
    editMarkedItems,
  };
};
